module.exports = __webpack_public_path__ + "img/ico-dir.9de9cdc1.svg";